import { render } from "./EarthquakeComparator.vue?vue&type=template&id=8865869e"
import script from "./EarthquakeComparator.vue?vue&type=script&lang=js"
export * from "./EarthquakeComparator.vue?vue&type=script&lang=js"

import "./EarthquakeComparator.vue?vue&type=style&index=0&id=8865869e&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__